// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q7tnL","right":"styles_right__vgFtz"};